import React from "react";
import SimpleCheckbox from "../checkBox/SimpleCheckbox";
import SimpleNumberField from "../inputNumberField/SimpleNumberField";
import { buttonNameConstants, shopifyConstants } from "../../../constants";

const ShopifyCompareAtPrice = ({
  field,
  fieldMappings,
  handleMappingChange,
}) => {
  const { isUseMarketPrice, compareAtPrice } = fieldMappings[field.name];

  const handleCheckboxChange = (name, value) => {
    handleMappingChange(field.name, {
      value: {
        isUseMarketPrice: value,
        compareAtPrice: value ? 0 : compareAtPrice,
      },
    });
  };

  const handleCompareAtPriceChange = (value) => {
    handleMappingChange(field.name, {
      value: {
        ...fieldMappings[field.name],
        compareAtPrice: value,
      },
    });
  };

  return (
    <div className="d-flex justify-content-center align-items-center gap-3">
      <SimpleNumberField
        value={compareAtPrice}
        onChange={handleCompareAtPriceChange}
        disabled={isUseMarketPrice}
        placeHolder={"0.00"}
        className={"w-100"}
      />
      <SimpleCheckbox
        name={shopifyConstants.USE_MARKET_PRICE}
        label={buttonNameConstants.USE_MARKET_PRICE}
        onChange={handleCheckboxChange}
        checked={isUseMarketPrice}
      />
    </div>
  );
};

export default ShopifyCompareAtPrice;
